import { StyledPublicThemes } from './PublicThemes.styled';
import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { StyledActivityIconCircle } from '@/shared/ActivityTypesList/ActivityTypesList.styled';
import { pxToVw } from '@/modules/styled/cssUnits';
import SearchThemes from '@/pages/Library/LibraryThemes/LibraryHeader/SearchThemes/SearchThemes';
import usePublicThemes from './usePublicThemes.hook';
import ThemeCard from '@/shared/ThemeCard/ThemeCard';
import { useRef } from 'react';
import KeepScroll from '@/shared/KeepScroll/KeepScroll';
import ActivityTypesList from '@/shared/ActivityTypesList/ActivityTypesList';
import PublicPage from '@/shared/PublicPage/PublicPage';
import { WithHugeDropLightDarkOneRightBg } from '@/shared/PublicPage/CustomBgPublicPage.styled';
import LibraryLevelFilter from '@/pages/Library/LibraryLevelFilter/LibraryLevelFilter';
import ActivityTypes from '@/constants/ActivityTypes';
import { Divider } from 'antd';
import EmptyThemesSearch from '@/shared/EmptyThemesSearch/EmptyThemesSearch';

export default function PublicThemes({ themes }) {
  const themeRefs = useRef({});
  const { state, actions } = usePublicThemes({ themes });
  return (
    <PublicPage withFooter StyledPublicPage={WithHugeDropLightDarkOneRightBg}>
      <KeepScroll
        refs={themeRefs}
        keepIn={[
          '/themes',
          ...Object.values(ActivityTypes.toSlug).map((slug) => `/${slug}`),
        ]}
        render={(keepScroll) => (
          <StyledPublicThemes>
            <div className="content-wrapper">
              <div className="themes-section">
                <div className="title">
                  <StyledActivityIconCircle
                    className="themes-circle-icon"
                    type={'themes'}
                    size={16}
                  >
                    <ActivityTypeIcon
                      type={'themes'}
                      color={'white'}
                      size={pxToVw(16)}
                    />
                  </StyledActivityIconCircle>
                  <h1>Themes</h1>
                </div>
                <LibraryLevelFilter className="mt" />
                <div className="themes-with-search">
                  <SearchThemes className="search" isPublic />
                  <div className="themes">
                    {state.themes.map((theme) => (
                      <ThemeCard
                        key={theme.id}
                        theme={theme}
                        themeRefs={themeRefs}
                        keepScroll={keepScroll}
                        publicPage
                      />
                    ))}
                  </div>
                  <EmptyThemesSearch
                    themes={state.themes}
                    loading={state.loading}
                  />
                  {state.themesNotInThisTag.length > 0 && !state.loading && (
                    <div className="themes-not-in-tag">
                      <Divider>Found at another level</Divider>
                      <div className="themes">
                        {state.themesNotInThisTag.map((theme) => (
                          <ThemeCard
                            key={theme.id}
                            theme={theme}
                            themeRefs={themeRefs}
                            keepScroll={() => {
                              actions.removeSelectedTag();
                              keepScroll();
                            }}
                            publicPage
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="activity-type-links">
              <ActivityTypesList />
            </div>
          </StyledPublicThemes>
        )}
      />
    </PublicPage>
  );
}
